module.exports = __webpack_public_path__ + "img/raytracer_framework.a879d68f.png";